import defaultLocale from '../languages/en.json';

const SHORT_MONTH_NAMES = [
  'jan',
  'feb',
  'mar',
  'apr',
  'may',
  'jun',
  'jul',
  'aug',
  'sep',
  'oct',
  'nov',
  'dec'
];

const LONG_MONTH_NAMES = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december'
];

const REPLACEMENTS = {
  // Day of the month without leading zeros (1 to 31)
  'j': function (dateTime) {
    return dateTime.getDate();
  },
  // A full numeric representation of a year, 4 digits (1999 or 2003)
  'Y': function (dateTime) {
    return dateTime.getFullYear();
  },
  // Numeric representation of a month, without leading zeros	(1 through 12)
  'n': function (dateTime) {
    return dateTime.getMonth() + 1;
  },
  // A full textual representation of a month, such as January or March	(January through December)
  'F': function (dateTime, localisation) {
    return localisation.datetime[LONG_MONTH_NAMES[dateTime.getMonth()]];
  },
  // A short textual representation of a month, three letters (Jan through Dec)
  'M': function (dateTime, localisation) {
    return localisation.datetime[SHORT_MONTH_NAMES[dateTime.getMonth()]];
  },
  // 24-hour format of an hour without leading zeros (0 through 23)
  'G': function (dateTime) {
    return dateTime.getHours();
  },
  // Minutes with leading zeros (00 to 59)
  'i': function (dateTime) {
    return ('00' + dateTime.getMinutes()).substr(-2);
  },
  // Seconds with leading zeros (00 to 59)
  's': function (dateTime) {
    return ('00' + dateTime.getSeconds()).substr(-2);
  },
  // Numeric representation of a month, with leading zeros (01 through 31)
  'm': function (dateTime) {
    return ('00' + REPLACEMENTS.n(dateTime)).substr(-2);
  },
  // Day of the month, 2 digits with leading zeros (01 to 31)
  'd': function (dateTime) {
    return ('00' + REPLACEMENTS.j(dateTime)).substr(-2);
  },
  // 24-hour format of an hour with leading zeros	(00 through 23)
  'H': function (dateTime) {
    return ('00' + REPLACEMENTS.G(dateTime)).substr(-2);
  },
  // 12-hour format of an hour without leading zeros (1 through 12)
  'g': function (dateTime) {
    return (REPLACEMENTS.G(dateTime) > 12 || REPLACEMENTS.G(dateTime) === 0)
      ? Math.abs(REPLACEMENTS.G(dateTime) - 12)
      : REPLACEMENTS.G(dateTime);
  },
  // 12-hour format of an hour with leading zeros (01 through 12)
  'h': function (dateTime) {
    return ('00' + REPLACEMENTS.g(dateTime)).substr(-2);
  },
  // Lowercase Ante meridiem and Post meridiem (am or pm)
  'a': function (dateTime) {
    return (REPLACEMENTS.G(dateTime) >= 12 || REPLACEMENTS.G(dateTime) === 0) ? 'pm' : 'am';
  },
  // Uppercase Ante meridiem and Post meridiem
  'A': function (dateTime, localisation) {
    return localisation.datetime[REPLACEMENTS.a(dateTime)].toUpperCase();
  }
};

const DATE_FORMAT_REGEX = new RegExp(`[${Object.keys(REPLACEMENTS).join('')}]`, 'g');

export default function formatDate (dateTime, format = 'Y-m-d', locale = defaultLocale) {
  if (!(dateTime instanceof Date)) return '';

  return format.replace(DATE_FORMAT_REGEX, function (match) {
    return REPLACEMENTS[match](dateTime, locale);
  });
}
